export default "__VITE_ASSET__a6fca743__"